import React from 'react';

import { Menu, Icon } from 'antd';


export class DataFlowItem extends React.Component {
    render () {
  
      const {data, actions} = this.props;
      if (data.flow && actions[data.flow.type] && data.flow_step_queue && data.flow_step_queue.step.note === 'S_QUALITY_CONTROL') {
        return actions[data.flow.type].map((elm) => {
          return (
            <div key={elm.title}>
              <img
                src={elm.icon}
                style={{width: '81px', cursor: 'pointer', marginTop: '-13px', marginLeft: "-16px"}}
                title={elm.title}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  window.location = `${ elm.link(data.uuid) }`;
                }}
              />
            </div>
          );
        });
      }
      return null;
    }
}


export class DeleteJobComponent extends React.Component {

  handleJobDelete = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.props.onJobDelete(this.props.data.uuid);
  }

  render() {
    return <Icon
        type="delete"
        style={{fontSize: "20px", marginRight: "0px", marginTop: "0px" }}
        title="Delete"
        align="center"
        alt="Delete"
        onClick={event => {this.handleJobDelete(event)}}
    />
  }
}


export default class JobsMenu extends React.Component {

    handleJobDelete = (event) => {
      event.domEvent.stopPropagation();
      event.domEvent.preventDefault();
      this.props.onJobDelete(this.props.data.uuid);
    }

    render () {
        let menuList = [];
        let width = null;
        const {data, actions} = this.props;
        const shouldRenderMenuItem = data.flow && actions[data.flow.type] && data.flow_step_queue && data.flow_step_queue.step.note === 'S_QUALITY_CONTROL';

        if (shouldRenderMenuItem) {
          width = "84px";
          menuList = [
            <Menu.Item key="1" style={{height: "42px"}}><DataFlowItem data={data} actions={actions}/></Menu.Item>,
            <Menu.Item key="2" align="center" title="Delete" style={{height: "38px"}} onClick={(event) => {this.handleJobDelete(event)}}>
                <Icon
                    type="delete"
                    style={{fontSize: "20px", marginRight: "0px", marginTop: "2px" }}
                    title="Delete"
                    align="center"
                    alt="Delete"
                />
            </Menu.Item>
          ]
        } else {
          menuList = [
            <Menu.Item key="2" align="center" title="Delete" onClick={(event) => {this.handleJobDelete(event)}}>
                <Icon 
                    type="delete"
                    style={{fontSize: "20px", marginRight: "0px", marginTop: "10px" }}
                    title="Delete"
                    align="center"
                    alt="Delete"
                />
            </Menu.Item>
          ]
        }
        return (
            <Menu style={{borderWidth: "1px", borderRightColor: "black", borderStyle: "solid", overflow: "hidden", width: width}}>
              {menuList}
            </Menu>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/Cases/actionStaffMenu.jsx